module.exports = __webpack_public_path__ + "static/p_four.clean.4e59e30c.jpeg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/p_four.clean.jpeg
// module id = 973
// module chunks = 10